export default __webpack_public_path__ + "static/media/perereka-sarandi.6916b20b.jpeg";